module.exports = ".custom-day {\n  text-align: center;\n  padding: 0.185rem 0.25rem;\n  height: 2rem;\n  width: 2rem; }\n\n.custom-day.focused {\n  background-color: #e6e6e6; }\n\n.custom-day.range, .custom-day:hover {\n  background-color: #0275d8;\n  color: white; }\n\n.custom-day.faded {\n  background-color: rgba(2, 117, 216, 0.5); }\n\n.custom-day .ngb-dp-weekdays {\n  margin-bottom: 1rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-date-range/app-date-range.component.scss
// module id = ./src/app/components/app-date-range/app-date-range.component.scss
// module chunks = main